function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 49 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M44.41 7.92l-.22-.24a12.25 12.25 0 00-15.9-1.38l3.21 9.69-9 6 4.5 12-13.5-13.5 9-6-2.68-8.11a12.24 12.24 0 00-16 1.31l-.23.23A12.88 12.88 0 002.91 25l19.88 20.5c.67.68 1.75.68 2.41 0l19.9-20.51a12.87 12.87 0 00-.69-17.07z"
})));